<template>
  <div v-if="profiles != null" id="show-profile-card">
    <v-card class="mt-3">
      <v-card-title>
        Profiles

        <v-spacer></v-spacer>
        <v-btn color="primary" icon @click.stop="createProfileDialog = true">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <create-profile-dialog
          :partner="partner"
          :open.sync="createProfileDialog"
          v-if="createProfileDialog"
        ></create-profile-dialog>
      </v-card-title>
      <v-card-text>
        <v-data-table
          v-if="profiles.length > 0"
          :headers="headers"
          :items="profiles"
          :items-per-page="10"
          dense
        >
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  small
                  :to="{ name: 'profil-details', params: { id: item.id } }"
                  ><v-icon>mdi-eye</v-icon></v-btn
                ></template
              >
              <span>Voir le profile</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <v-skeleton-loader v-else type="table"></v-skeleton-loader>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { onMounted, toRefs } from "@vue/composition-api";
import { useProfile } from "@/composables/profile";
import CreateProfileDialog from "../Profile/CreateProfileDialog";

export default {
  components: { CreateProfileDialog },
  props: {
    partner: Object,
  },
  setup(props) {
    const { profiles, listProfiles, profileData } = useProfile();
    onMounted(() => {
      listProfiles(props.partner.id);
    });

    return {
      ...toRefs(profileData),
      profiles,
      headers: [
        { text: "Action", value: "actions" },

        { text: "Description", value: "description" },
        { text: "Libellé", value: "label" },
      ],
    };
  },
};
</script>
